<template>
  <el-table
    :data="scheduleDayTimes"
    size="mini"
    stripe
  >
    <el-table-column
      label=""
      prop="day"
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />
    <el-table-column
      label="Ready"
      prop="ready"
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />
    <el-table-column
      label="Opening"
      prop="opening"
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />
    <el-table-column
      label="Closing"
      prop="closing"
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />
  </el-table>
</template>

<script>
export default {
  props: {
    schedule: {
      type: Object,
      required: true
    }
  },
  computed: {
    scheduleDayTimes () {
      return [
        {
          day: 'Monday',
          ready: this.schedule.monday_ready_time ? this.schedule.monday_ready_time : '-',
          opening: this.schedule.monday_open_time ? this.schedule.monday_open_time : '-',
          closing: this.schedule.monday_closing_time ? this.schedule.monday_closing_time : '-'
        },
        {
          day: 'Tuesday',
          ready: this.schedule.tuesday_ready_time ? this.schedule.tuesday_ready_time : '-',
          opening: this.schedule.tuesday_open_time ? this.schedule.tuesday_open_time : '-',
          closing: this.schedule.tuesday_closing_time ? this.schedule.tuesday_closing_time : '-'
        },
        {
          day: 'Wednesday',
          ready: this.schedule.wednesday_ready_time ? this.schedule.wednesday_ready_time : '-',
          opening: this.schedule.wednesday_open_time ? this.schedule.wednesday_open_time : '-',
          closing: this.schedule.wednesday_closing_time ? this.schedule.wednesday_closing_time : '-'
        },
        {
          day: 'Thursday',
          ready: this.schedule.thursday_ready_time ? this.schedule.thursday_ready_time : '-',
          opening: this.schedule.thursday_open_time ? this.schedule.thursday_open_time : '-',
          closing: this.schedule.thursday_closing_time ? this.schedule.thursday_closing_time : '-'
        },
        {
          day: 'Friday',
          ready: this.schedule.friday_ready_time ? this.schedule.friday_ready_time : '-',
          opening: this.schedule.friday_open_time ? this.schedule.friday_open_time : '-',
          closing: this.schedule.friday_closing_time ? this.schedule.friday_closing_time : '-'
        },
        {
          day: 'Saturday',
          ready: this.schedule.saturday_ready_time ? this.schedule.saturday_ready_time : '-',
          opening: this.schedule.saturday_open_time ? this.schedule.saturday_open_time : '-',
          closing: this.schedule.saturday_closing_time ? this.schedule.saturday_closing_time : '-'
        },
        {
          day: 'Sunday',
          ready: this.schedule.sunday_ready_time ? this.schedule.sunday_ready_time : '-',
          opening: this.schedule.sunday_open_time ? this.schedule.sunday_open_time : '-',
          closing: this.schedule.sunday_closing_time ? this.schedule.sunday_closing_time : '-'
        }
      ]
    }
  }
}
</script>

<style>

</style>
